import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_DOCTOR_CONSULTATION } from "../../action-types/actions";

export const getDoctorConsultationClaims = createAsyncThunk(
  ACTIONS_GET_DOCTOR_CONSULTATION.getDoctorConsultations,
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.doctorConsultation}?page=${page}&limit=${limit}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message ||
            "Failed to fetch doctor consultation claims",
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching doctor consultation claims:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching doctor consultation claims";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
